import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const JobCategorySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formJobCategory">
                    <Form.Label>Gesuchte Stellenart</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="jobCategory"
                        value={values.jobCategory}
                        isValid={touched.jobCategory && !errors.jobCategory}
                        isInvalid={errors.jobCategory}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.JobCategory.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.jobCategory}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};